import React from "react";
import { Link, Navigate, Outlet, useNavigate } from "react-router-dom";
import { useClientAuth } from "../../hooks/useClientAuth";
import "../../pages/client/client.css";

const ClientLayout = () => {
  const navigate = useNavigate();
  const { clientUser, logout } = useClientAuth();

  if (!clientUser) {
    return <Navigate to='/client/login' replace />;
  }

  const clientInitial = clientUser.name.trim().charAt(0).toUpperCase() || "C";

  return (
    <div className='client-shell'>
      <header className='client-topbar'>
        <div className='client-topbar-inner'>
          <Link to='/client' className='client-brand'>
            <span className='client-brand-mark'>D24</span>
            <span>
              <strong>Dialin24 Client Panel</strong>
              <small>Live project visibility and progress tracking</small>
            </span>
          </Link>

          <div className='client-userbar'>
            <div className='client-user-chip'>
              <span className='client-avatar'>{clientInitial}</span>
              <span className='client-user-meta'>
                <strong>{clientUser.name}</strong>
                <small>{clientUser.email}</small>
              </span>
            </div>
            <button
              type='button'
              className='btn btn-outline-dark btn-sm'
              onClick={() => {
                logout();
                navigate('/client/login', { replace: true });
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      <main className='client-main'>
        <Outlet />
      </main>
    </div>
  );
};

export default ClientLayout;
